export default __webpack_public_path__ + "static/media/print-icon.8c367f1c.svg";